import { render, staticRenderFns } from "./xlsPoints.vue?vue&type=template&id=2167aab0&scoped=true&"
import script from "./xlsPoints.vue?vue&type=script&lang=js&"
export * from "./xlsPoints.vue?vue&type=script&lang=js&"
import style0 from "./xlsPoints.vue?vue&type=style&index=0&id=2167aab0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2167aab0",
  null
  
)

export default component.exports